import { version } from '../../package.json'

export const dsVersion = (): string => {
	return version
}
